module.exports = __webpack_public_path__ + "img/svg/competition-card.6770e9e220fd44e28e5348c1458efa89.svg";